<template>
    <div id="landing-banner">
        <!--=====================================-->
        <!--=        Project Area Start         =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <div class="project-add-banner bg-gradient-green1" data-sal="slide-up" data-sal-duration="800">
                    <div class="content">
                        <div class="row center">
                            <div class="col-sm-12 col-md-10">
                                <h2 class="dark w-75 mb-0">
                                    Consulta términos y condiciones.
                                </h2>
                            </div>
                            <div class="col-sm-2 col-md-2">
                                <button @click.stop="openNewTabWithUrl(terms)" class="axil-btn rg-btn-dark rg-style-button">Consultar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "Footer",
    components: {
    },
    data() {
        return {
            logo_base: "https://cdn.redgirasol.com/nuevo_portal/banners/banner-",
            terms: "https://soporte.redgirasol.com/support/solutions/articles/48001247806-t%C3%A9rminos-y-condiciones-promotores-de-inversi%C3%B3n-"
        }
    }
}

</script>

<style scoped>
.center {
    align-items: center;
}
</style>